import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_fac_social_insurance_contributions_both'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_fac_social_insurance_contributions_both',
  name: 'Which of the following facility social insurance contributions (both calculations and types required) are out of line with legal requirements? (SELECT all that apply with an "X")',
  description:
    'Consult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'PENSION_PROVIDENT_FUND',
      text: 'Pension/ Provident fund',
      externalIds: [
        {
          id: 'wb-wage-78',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MEDICAL',
      text: 'Medical',
      externalIds: [
        {
          id: 'wb-wage-79',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORK_RELATED_INJURY_ILLNESS_DEATH',
      text: 'Work-related injury/ illness/ death',
      externalIds: [
        {
          id: 'wb-wage-80',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'UNEMPLOYMENT',
      text: 'Unemployment',
      externalIds: [
        {
          id: 'wb-wage-81',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MATERNITY',
      text: 'Maternity',
      externalIds: [
        {
          id: 'wb-wage-82',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'wb-wage-83',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'wb-wage-84f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NOT_APPLICABLE_WORKER_AND_FACILITY_CONTRIBUTIONS_CANNOT_BE_SEPA',
      text: 'Not applicable - worker and facility contributions cannot be separated and/ or broken down',
      externalIds: [
        {
          id: 'wb-wag-109x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE_FACILITY_CALCULATES_ALL_TYPES_OF_LEGALLY_REQU',
      text: 'None of the above (facility calculates all types of legally required social insurance contributions in line with legal requirements)',
      externalIds: [
        {
          id: 'wb-wage-85',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TOTAL_FACILITY_CONTRIBUTION_AMOUNT_NO_BREAKDOWN_POSSIBLE_IS_IN_',
      text: 'Total facility contribution amount (no breakdown possible) is in line with legal requirements',
      externalIds: [
        {
          id: 'wb-wag-110x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'NUMBER',
        text: 'If yes, how many workers are covered by this other insurance?\n',
        externalIds: [
          {
            id: 'wb-wage-87f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'VIETNAM_DOES_THE_FACILITY_SUBMIT_CLAIMS_FOR_SICK_LEAVE_AND_MATE',
      text: 'Vietnam: Does the facility submit claims for sick leave and maternity leave to the social insurance agency within 10 days, as legally required?',
      externalIds: [
        {
          id: 'wb-wag-119',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'VIETNAM_DOES_THE_FACILITY_COMPLY_WITH_APPLICABLE_LEGAL_REQUIREM',
      text: 'Vietnam: Does the facility comply with applicable legal requirements when workers have occupational accidents and diseases?',
      externalIds: [
        {
          id: 'wb-wag-120',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'INDONESIA_DOES_THE_FACILITY_COMPLY_WITH_ALL_REQUIREMENTS_RELATE_HEALTH',
      text: "Indonesia: Does the facility comply with all requirements related to national social insurance (BPJS Ketenagakerjaan), including registering workers, paying employer contributions, and collecting and forwarding workers' contributions?",
      externalIds: [
        {
          id: 'wb-wage-88',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'INDONESIA_DOES_THE_FACILITY_COMPLY_WITH_ALL_REQUIREMENTS_RELATE_SOCIAL',
      text: 'Indonesia: Does the facility comply with all requirements related to National healthcare funds (BPJS kesehatan), including registering workers, paying employer contributions, and collecting and forwarding workers’ contribution?',
      externalIds: [
        {
          id: 'wb-wage-89',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'PENSION_PROVIDENT_FUND',
                'MEDICAL',
                'WORK_RELATED_INJURY_ILLNESS_DEATH',
                'UNEMPLOYMENT',
                'MATERNITY',
                'OTHER',
                'NOT_APPLICABLE_WORKER_AND_FACILITY_CONTRIBUTIONS_CANNOT_BE_SEPA',
                'NONE_OF_THE_ABOVE_FACILITY_CALCULATES_ALL_TYPES_OF_LEGALLY_REQU',
                'TOTAL_FACILITY_CONTRIBUTION_AMOUNT_NO_BREAKDOWN_POSSIBLE_IS_IN_',
                'VIETNAM_DOES_THE_FACILITY_SUBMIT_CLAIMS_FOR_SICK_LEAVE_AND_MATE',
                'VIETNAM_DOES_THE_FACILITY_COMPLY_WITH_APPLICABLE_LEGAL_REQUIREM',
                'INDONESIA_DOES_THE_FACILITY_COMPLY_WITH_ALL_REQUIREMENTS_RELATE_HEALTH',
                'INDONESIA_DOES_THE_FACILITY_COMPLY_WITH_ALL_REQUIREMENTS_RELATE_SOCIAL',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wage-77',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9120,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
